export default {
  app: { name: 'ProofFleet', offline: 'Нет связи', queued: 'В очереди: {{count}}' },
  login: {
    title: 'Вход водителя',
    phone: 'Телефон',
    pin: 'PIN-код',
    submit: 'Войти',
    error: 'Неверный телефон или PIN',
    deviceBlocked: 'Устройство не привязано. Обратитесь к менеджеру.',
    language: 'Язык',
  },
  policy: {
    title: 'Регламент осмотров',
    version: 'Редакция {{version}}',
    accept: 'Прочитал и принимаю',
    accepting: 'Отправляем…',
    required: 'Чтобы продолжить, ознакомьтесь с регламентом флота.',
    changed: 'Регламент изменился. Перечитайте актуальную редакцию.',
  },
  unit: {
    title: 'Выберите машину',
    scan: 'Сканировать QR на двери',
    manual: 'Выбрать из списка',
    search: 'Номер юнита',
    empty: 'Машины не найдены',
    notRecognized: 'Наклейка не распознана',
  },
  briefing: {
    title: 'Незакрытые дефекты',
    subtitle: 'Отмечены на этой машине ранее. Подтвердите, что видели их.',
    none: 'Незакрытых дефектов нет',
    acknowledge: 'Подтверждаю, что видел',
    reported: 'Заявлено {{date}}',
  },
  inspection: {
    title: 'Осмотр',
    progress: '{{done}} из {{total}}',
    ok: 'Исправно',
    defect: 'Дефект',
    skip: 'Неприменимо',
    photo: 'Снять фото',
    photoRequired: 'Фото обязательно',
    retake: 'Переснять',
    note: 'Заметка',
    value: 'Значение',
    enterValue: 'Введите значение',
    limit: 'Предел: {{value}}{{unit}}',
    verdictOk: 'В норме',
    verdictWarn: 'Ниже нормы',
    verdictCritical: 'Критично',
    next: 'Далее',
    back: 'Назад',
    finish: 'Завершить осмотр',
    incomplete: 'Заполнены не все пункты',
    submitting: 'Отправляем…',
  },
  done: {
    title: 'Осмотр отправлен',
    queued: 'Осмотр сохранён и уйдёт, когда появится связь',
    verdictPass: 'Замечаний нет',
    verdictDefects: 'Обнаружены замечания',
    verdictCritical: 'Обнаружен критический дефект',
    notified: 'Ответственный уведомлён',
    again: 'Осмотреть другую машину',
  },
  common: {
    retry: 'Повторить',
    cancel: 'Отмена',
    close: 'Закрыть',
    loading: 'Загрузка…',
    error: 'Что-то пошло не так',
    logout: 'Выйти',
  },
  push: {
    ask: "Присылать уведомление, когда по вашей машине появится дефект?",
    enable: "Включить уведомления",
    install: "Чтобы получать уведомления на iPhone, добавьте приложение на экран «Домой»: «Поделиться» → «На экран „Домой“».",
    done: "Уведомления включены.",
  },
  voice: {
    record: "Записать голосом",
    stop: "Стоп",
    rerecord: "Записать заново",
    denied: "Доступ к микрофону запрещён",
  },
  history: {
    title: "Мои осмотры",
    openDefects: "Открытые дефекты по моим машинам",
    inspections: "Сданные",
    empty: "Пока ничего не сдано",
    clean: "Без замечаний",
    findings: "Замечаний: {{count}}",
    critical: "Критично: {{count}}",
    back: "К машинам",
    link: "История",
  },
} as const;
